import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageNotificationService {
  private unreadMessagesUpdatedSource = new Subject<void>();

  unreadMessagesUpdated$ = this.unreadMessagesUpdatedSource.asObservable();

  notifyUnreadMessagesUpdated() {
    this.unreadMessagesUpdatedSource.next();
  }
}